import * as React from "react";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { Icon } from "../../generic/icon/Icon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var OfferLevelRewardPaymentListItem = function (_a) {
    var levelReward = _a.levelReward;
    var resourceReward = levelReward.resourceReward, requPlayerLevel = levelReward.requPlayerLevel;
    var icon;
    var amount = 0;
    if (resourceReward) {
        var resource = selectResourceInfo(resourceReward[0].resourceId);
        icon = getResourceIcon(resource);
        amount = resourceReward[0].amount;
    }
    var replacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(requPlayerLevel || 0)],
    ]);
    return (React.createElement("div", { className: IdStyles.OfferRewardListItem + " offer-reward-item" },
        React.createElement(TextLoca, { id: IdLoca.reachLevelX, replacements: replacements, className: IdStyles.TextBoldPrimary }),
        React.createElement("div", { className: IdStyles.OfferLevelRewardContainer + " flex flex--row flex--guts" },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
            React.createElement(NumberFormat, { amount: amount, className: IdStyles.TextBoldPrimary }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferLevelRewardPaymentListItem.tsx
// module id = 2919
// module chunks = 3